<template>
  <div class="monitoring-realtime-container">
    <div class="box-left">
      <div class="charts-box charts-1">
        <div class="title">
          <span class="zsf-icon zsf-icon-touxiang"></span>
          <span>人员统计</span>
        </div>
        <div id="left-echarts" style="width:360px;height:220px;"></div>
      </div>
      <div class="charts-box charts-2">
        <div class="title">
          <span class="zsf-icon zsf-icon-shebei"></span>
          <span>报警统计</span>
        </div>
        <div id="left-echarts2" style="width:360px;height:220px;"></div>
      </div>
    </div>
    <div class="box-right">
      <v-ship-map-drawline ref="shipmap" :containerHeight="500" :ship_img="ship_img"></v-ship-map-drawline>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {navigation} from "../../config.js";
  import {tool} from "../../common/js/tool.js";
  import {api} from "../../common/js/api.js";
  import ShipMapDrawline from '../../components/ship-map-drawline-location-api.vue';
  import {mock} from '../../common/js/mock2.js';
  export default {
    data() {
      return {
        myChart3: null,
        myChart3Data: [],
        count1: 0,
        myChart4: null,
        myChart4Data: [],
        count2: 0,
        ship_img: {
          url: '',
          width: 0,
          height: 0
        }
      };
    },

    computed: {},

    created() {
//    apiUser.login({ username: "zsf", password: "123456" }).then(res => {
//      console.log(res);
//    });
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    mounted() {
      this.myChart3Data = [
        {name: "铆工", value: tool.mathRandom(10, 100)},
        {name: "电焊工", value: tool.mathRandom(10, 100)},
        {name: "涂漆工", value: tool.mathRandom(10, 100)},
        {name: "吊车工", value: tool.mathRandom(10, 100)},
        {name: "切割工", value: tool.mathRandom(10, 100)}
      ];
      let count1 = 0;
      for (let i = 0; i < this.myChart3Data.length; i++) {
        count1 += this.myChart3Data[i].value;
      }
      this.count1 = count1;
      this.leftEcharts();
      this.myChart4Data = [
        {name: "铆工", value: tool.mathRandom(1, 20)},
        {name: "电焊工", value: tool.mathRandom(1, 20)},
        {name: "涂漆工", value: tool.mathRandom(1, 20)},
        {name: "吊车工", value: tool.mathRandom(1, 20)},
        {name: "切割工", value: tool.mathRandom(1, 20)}
      ];
      let count2 = 0;
      for (let i = 0; i < this.myChart4Data.length; i++) {
        count2 += this.myChart4Data[i].value;
      }
      this.count2 = count2;
      this.leftEcharts2();
    },

    methods: {
      getStationById(id){
        let stations = mock.station;
        let info = {};
        for (let i = 0; i < stations.length; i++) {
          if (id === stations[i].id) {
            info = stations[i];
          }
        }
        return info;
      },
      leftEcharts() {
        var dom = document.getElementById("left-echarts");
        if (
            this.myChart3 !== null &&
            this.myChart3 !== "" &&
            this.myChart3 !== undefined
        ) {
          this.myChart3.dispose();
        }
        this.myChart3 = this.$echarts.init(dom);
        var option = {
          title: {
            zlevel: 0,
            text: this.count1,
            top: "center",
            left: "175",
            textAlign: "center"
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "55%"],
              label: {
                formatter: "  {b|{b}：}{c}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 22,
                    align: "center"
                  },
                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 25
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              },
              data: this.myChart3Data
            }
          ]
        };
        if (option && typeof option === "object") {
          this.myChart3.setOption(option, true);
        }
      },
      leftEcharts2() {
        var dom = document.getElementById("left-echarts2");
        if (
            this.myChart4 !== null &&
            this.myChart4 !== "" &&
            this.myChart4 !== undefined
        ) {
          this.myChart4.dispose();
        }
        this.myChart4 = this.$echarts.init(dom);
        var option = {
          title: {
            zlevel: 0,
            text: this.count2,
            top: "center",
            left: "175",
            textAlign: "center"
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "55%"],
              label: {
                formatter: "  {b|{b}：}{c}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 22,
                    align: "center"
                  },
                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 25
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              },
              data: this.myChart4Data
            }
          ]
        };
        if (option && typeof option === "object") {
          this.myChart4.setOption(option, true);
        }
      }
    },

    components: {
      'v-ship-map-drawline': ShipMapDrawline,
    },

    watch: {
      $route(to, from){
        let personId = this.$route.query.id;
        let personName = this.$route.query.name;
        if (personId) {
          //this.$refs.shipmap.showPersonLocation(mock.station[tool.mathRandom(0, 5)], personName);
          api.currentDisplay({id: personId}).then((res) => {
            let tmp = res.data[0];
            console.log(tmp);
            tmp.point = this.getStationById(tmp.station_id);
            console.log(tmp);
            this.$refs.shipmap.showPersonLocation(res.data[0], personName);
          })
        }
      },
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import url("../../common/less/variable.less");

  .monitoring-realtime-container {
    width: 100%;
    display: flex;
    align-items: stretch;
    padding: 15px;
    .box-left {
      width: 360px;
      margin-right: 15px;
      height: auto;
      background: #e6e8ef;
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      .charts-box {
        width: 360px;
        height: 260px;
        padding-top: 30px;
        .title {
          text-align: center;
          color: #30417a;
          span {
            font-size: 17px;
          }
          .zsf-icon {
            font-size: 17px;
            margin-right: 3px;
          }
        }
        &.charts-1 {
          .charts-left {
            background: linear-gradient(
                135deg,
                rgba(39, 60, 158, 1) 0%,
                rgba(92, 112, 207, 1) 100%,
                rgba(93, 113, 208, 1) 100%
            );
          }
        }
        &.charts-2 {
          .charts-left {
            background: linear-gradient(
                135deg,
                rgba(202, 59, 59, 1) 0%,
                rgba(255, 133, 37, 1) 100%,
                rgba(93, 113, 208, 1) 100%
            );
            &:after {
              border-left: 10px solid #e8683b;
            }
            .count {
              &:before {
                background: rgba(251, 116, 82, 1);
              }
            }
          }
        }
      }
    }
    .box-right {
      width: 0;
      flex: 1;
      height: 535px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      padding: 15px;
      overflow: hidden;
    }
  }
</style>
